import React, {useState} from "react";
import {Loading} from "./Loading";
import {registerForTraining} from "./Api";
import {InputPopup} from "./InputPopup";
import {RegistrationList} from "./RegistrationList";
import {CancelRegistration} from "./CancelRegistration";
import "./Course.css";
import * as t from "./types";

enum Message {
  RegistrationSucceeded,
  RegistrationFailed,
  UnregistrationSucceeded,
  UnregistrationFailed,
}

interface CourseProps {
  courseData: t.ICourseData;
  notifyUpdate: (data: t.IData) => void;
}

type RegStatus = [number, Message, string];

export const Course = (props: CourseProps) => {
  // console.log("Rendering Course");
  // console.log(props);
  const [isQuerying, setIsQuerying] = useState(false);
  const [isShowingPopup, setIsShowingPopup] = useState(false);
  const [
    isShowingCancelRegistration,
    setIsShowingCancelRegistration,
  ] = useState(false);
  const [registrationStatusList, setRegistrationStatusList]: [
    RegStatus[],
    any
  ] = useState([]);

  const {courseData, notifyUpdate} = props;
  // console.log("here?");
  // console.log(courseData);

  if (!courseData) {
    return <td></td>;
  }

  const {is_registration_allowed, course} = courseData;
  // console.log("nope");

  if (!is_registration_allowed) {
    return <td className="course disabled">{courseData.exclusion.reason}</td>;
  }

  const {
    maximum_registrations,
    id,
    start_time,
    end_time,
    current_registrations,
    registrations,
  } = course;
  const remaining = maximum_registrations - current_registrations;
  // console.log(`isQuerying? ${isQuerying}`);
  const tryRegister = (name: string) => {
    //disable button
    //show loader
    if (name === "") {
      return;
    }
    setIsShowingPopup(false);
    setIsQuerying(true);
    //do apireq
    registerForTraining(id, name)
      .then((resp: t.IScheduleResponse) => {
        setIsQuerying(false);
        if (resp.status === "success") {
          registrationStatusList.push([
            course.id,
            Message.RegistrationSucceeded,
            name,
          ]);
          setRegistrationStatusList(registrationStatusList);
          //if worked, reload using new info using callback to mainarea
          notifyUpdate(resp.data);
          //dispaly message that it worked
        } else {
          registrationStatusList.push([
            course.id,
            Message.RegistrationFailed,
            name,
          ]);
          setRegistrationStatusList(registrationStatusList);
          //display message that it failed
        }
      })
      .catch((err) => {
        //console.log("error during registration process..");
        //console.log(err);
        registrationStatusList.push([
          course.id,
          Message.RegistrationFailed,
          name,
        ]);
        setRegistrationStatusList(registrationStatusList);
      });
    //if not, show error message
  };

  const cancelRegistration = () => {
    setIsShowingPopup(false);
  };
  const btn =
    remaining > 0 ? (
      <button
        onClick={() => {
          setIsShowingPopup(true);
        }}
      >
        Anmeldung
      </button>
    ) : (
        <div />
      );
  const unregButton = !isShowingCancelRegistration ? (
    <button
      onClick={() => {
        setIsShowingCancelRegistration(true);
      }}
    >
      Abmelden
    </button>
  ) : (
      <div />
    );
  const onUnregSuccess = () => {
    registrationStatusList.push([
      course.id,
      Message.UnregistrationSucceeded,
      "",
    ]);
    setRegistrationStatusList(registrationStatusList);
    setIsShowingCancelRegistration(false);
  };
  const registrationStatusMessages = registrationStatusList.map((r) => {
    // const [cid, message, ..._] = r;
    const cid = r[0];
    const message = r[1];
    if (cid !== course.id) {
      // is this possible??
      return <div />;
    }
    let output;
    switch (message) {
      case Message.RegistrationSucceeded: {
        output = <p className="registration-success">Anmeldung erfolgreich.</p>;
        break;
      }
      case Message.RegistrationFailed: {
        output = (
          <p className="registration-failure">Anmeldung fehlgeschlagen.</p>
        );
        break;
      }
      case Message.UnregistrationSucceeded: {
        output = <p className="registration-success">Abmeldung erfolgreich.</p>;
        break;
      }
      case Message.UnregistrationFailed: {
        output = (
          <p className="registration-failure">Abmeldung fehlgeschlagen.</p>
        );
        break;
      }
    }
    return output;
  });
  if (isQuerying) {
    return <Loading />;
  }
  return (
    <td className="course">
      <p className="bold">
        {start_time}-{end_time}
      </p>
      <p>Plätze Frei: {remaining}</p>
      <p>Gesamt Plätze: {maximum_registrations}</p>
      {btn}
      {registrationStatusMessages}
      {isShowingPopup ? (
        <InputPopup
          register={tryRegister}
          cancel={cancelRegistration}
          course={course}
        />
      ) : (
          <div />
        )}
      {unregButton}
      {isShowingCancelRegistration ? (
        <CancelRegistration
          registrations={registrations}
          notifyUpdate={notifyUpdate}
          notifySuccess={onUnregSuccess}
          cancel={() => setIsShowingCancelRegistration(false)}
        />
      ) : (
          <div />
        )}
      <RegistrationList registrations={course.registrations}></RegistrationList>
    </td>
  );
};
